import { Injectable, OnInit } from '@angular/core';
import { Router, RoutesRecognized } from '@angular/router';
import { filter, pairwise } from 'rxjs/operators';

@Injectable({ providedIn: 'root' })
export class routeService {

    previousUrl: string;

    constructor(private router: Router) { }

    Init() {                
        this.router.events
            .pipe(filter((evt: any) => evt instanceof RoutesRecognized), pairwise())
            .subscribe((events: RoutesRecognized[]) => {                
                this.previousUrl = events[0].urlAfterRedirects;
            });
    }

}